(function (ws) {
    'use strict';
    ws.views.tooltipModal = Backbone.View.extend({

        events: {
            'click [data-event="closeTooltip"]': 'close',
            'click [data-event="openTooltip"]': 'open',
            'click .comp-tooltip-label': 'open',
            'mouseover .comp-tooltip-label': 'open',
            'mouseout .comp-tooltip-label': 'close',
            'touchstart .comp-tooltip-label': 'open',
            'touchend .comp-tooltip-label': 'close'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.eventAgg.on('removeTooltipView', this.close.bind(this));

            $('#order-table tbody').on('mouseover', '.comp-tooltip-label', this.open.bind(this));
            $('#order-table tbody').on('mouseout', '.comp-tooltip-label', this.close.bind(this));

            this.$content = this.$('.comp-tooltip-content');
            this.$tooltips = $('.comp-tooltip-content');
        },

        /**
         * Opens the tooltip
         */
        open: function (ev) {
            ev.preventDefault();

            // close all tooltips
            this.closeAll();

            // show this tooltip
            this.toggle($(ev.currentTarget).next('.comp-tooltip-content'), true);
        },

        /**
         * Close all tooltips
         */
        closeAll: function () {
            this.$tooltips.hide();
        },

        /**
         * Toggle Tooltip
         * @param {Object} element
         * @param {boolean} state
         */
        toggle: function (element, state) {
            element.toggle(state);
        },

        /**
         * Closes the tooltip and destroys the view
         */
        close: function (ev) {
            if (ev) {
                ev.preventDefault();
                ev.stopPropagation();
                this.toggle($(ev.currentTarget).next('.comp-tooltip-content'), false);
            }
        }

    });
})(westcon);
